import React, { useEffect } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import Button from '@/ui/components/shared/Button';
import Link from 'next/link';
import CelebrateIcon from '../../../../../../public/images/celebrate-icon.svg';
import LinkedInIcon from '../../../../../../public/images/linkedin-icon.svg';
import FacebookIcon from '../../../../../../public/images/facebook-icon.svg';
import InstagramIcon from '../../../../../../public/images/instagram-icon.svg';
import YoutubeIcon from '../../../../../../public/images/youtube-icon.svg';

export default function ThankYouForApplication() {
  const t = useTranslations('jobApplicationThankYou');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex justify-center">
      <div className="max-w-[56rem] overflow-y-hidden px-6">
        <div className="mb-8 flex justify-center">
          <Image
            src={CelebrateIcon}
            alt=""
            width={32}
            height={32}
            className="h-14 w-14 sm:h-20 sm:w-20"
          />
        </div>
        <div className="text-center">
          <h1 className="mb-8 text-xl font-bold sm:text-4xl">
            {t('Thank you for your application')}
            <span className="text-primary-100">!</span>
          </h1>
          <p className="mb-12 sm:text-lg">
            {t(
              'We appreciate your interest in joining Nuki Our hiring team is currently reviewing your application',
            )}
            <br />
            <br />
            {t("If your qualifications match our needs, we'll be in touch within 2 weeks")}
          </p>
          <h2 className="mb-10 text-lg font-bold sm:text-3xl">{t('Stay connected!')}</h2>
        </div>
        <div className="flex justify-center">
          <div className="mb-16 grid grid-cols-2 items-center justify-center gap-4 sm:grid-cols-4">
            <Button
              className="inline-flex items-center px-3 py-2"
              href="https://www.linkedin.com/company/nuki-home-solutions-gmbh"
              openInNewTab
            >
              <Image
                src={LinkedInIcon}
                alt=""
                className="mr-1 inline-block h-6 w-6"
                width={32}
                height={32}
              />{' '}
              LINKEDIN
            </Button>
            <Button
              className="inline-flex items-center px-3 py-2"
              href="https://www.instagram.com/nuki_smart_lock/"
              openInNewTab
            >
              <Image
                src={InstagramIcon}
                alt=""
                className="mr-1 inline-block h-6 w-6"
                width={32}
                height={32}
              />{' '}
              INSTAGRAM
            </Button>
            <Button
              className="inline-flex items-center px-3 py-2"
              href="https://www.youtube.com/c/NukiSmartLock"
              openInNewTab
            >
              <Image
                src={YoutubeIcon}
                alt=""
                className="mr-1 inline-block h-6 w-6"
                width={32}
                height={32}
              />{' '}
              YOUTUBE
            </Button>
            <Button
              className="inline-flex items-center px-3 py-2"
              href="https://www.facebook.com/nuki.smartlock/"
              openInNewTab
            >
              <Image
                src={FacebookIcon}
                alt=""
                className="mr-1 inline-block h-6 w-6"
                width={32}
                height={32}
              />{' '}
              FACEBOOK
            </Button>
          </div>
        </div>
        <hr />
        <div className="mt-8 text-center">
          <p className="sm:text-lg">
            {t('Questions? Contact us at:')}{' '}
            <Link className="underline" href="mailto:career@nuki.io">
              career@nuki.io
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
